import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import arraySort from 'array-sort'
import colors from '../../../configuration/colors'
import { pluralizeString } from '../../../utils/string'
import { Caption1, Caption5 } from '../../styled/typography/typography'

const EvidenceStatementsListTooltip = styled.ol`
  margin: 0;
  padding-left: 0;
  list-style-position: inside;
`

const SkillEvidenceStatementTooltip = styled(Caption1).attrs({
  as: 'li',
  white: true
})`
  list-style-type: disc;
  padding-bottom: 7px;
  padding-left: 5px;
  text-indent: -5px;
  @-moz-document url-prefix() {
    padding-left: 0;
    text-indent: 0;
  }
`

const SkillEvidenceStatementLabel = styled.label`
  position: relative;
  left: -7px;
  line-height: 1.4;
  @-moz-document url-prefix() {
    left: 0;
  }
`

const EvidenceStatementsList = styled.ul`
  margin: 0;
  padding-left: 17px;
`

const SkillEvidenceStatement = styled(Caption1).attrs({
  as: 'li'
})`
  color: ${colors.charcoal4};
  list-style-type: disc;
  padding-bottom: 7px;
`

const EvidenceStatements = ({ evidenceStatements, isTooltip = true }) =>
  isTooltip ? (
    <div style={{ padding: '8px 0' }}>
      <Caption1 white
        style={{ marginBottom: '10px', fontWeight: 700 }}
      >
        {pluralizeString({
          count: evidenceStatements.length,
          singular: 'Example:',
          plural: 'Examples:'
        })}
      </Caption1>
      <EvidenceStatementsListTooltip>
        {arraySort(evidenceStatements, ['sort_order']).map(es => (
          <SkillEvidenceStatementTooltip key={es.id}>
            <SkillEvidenceStatementLabel>
              {es.description}
            </SkillEvidenceStatementLabel>
          </SkillEvidenceStatementTooltip>
        ))}
      </EvidenceStatementsListTooltip>
    </div>
  ) : (
    <React.Fragment>
      <Caption5 style={{ marginBottom: '7px' }}>
        {pluralizeString({
          count: evidenceStatements.length,
          singular: 'Example:',
          plural: 'Examples:'
        })}
      </Caption5>
      <EvidenceStatementsList>
        {arraySort(evidenceStatements, ['sort_order']).map(es => (
          <SkillEvidenceStatement key={es.id}>
            {es.description}
          </SkillEvidenceStatement>
        ))}
      </EvidenceStatementsList>
    </React.Fragment>
  )

EvidenceStatements.propTypes = {
  evidenceStatements: PropTypes.array,
  isTooltip: PropTypes.bool.isRequired
}

export default EvidenceStatements
